/* ==========================================================================
   COFFEE CUCKS — theme.js
   Vanilla, zero dependencies, zero external requests.
   Progressive enhancement: every buy/cart path works without JS except the
   gift-wrap bump, which is hidden until JS is present (.js-only).
   ========================================================================== */
(function () {
  'use strict';

  /* Mirrors Liquid's `money_without_trailing_zeros`: $60, but $60.50.
     The buy button reads "BUY THE PAIR — $60", so JS must not print "$60.00". */
  var money = function (cents, format) {
    var whole = cents % 100 === 0;
    var n = whole ? String(cents / 100) : (cents / 100).toFixed(2);
    var c = n.replace('.', ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, n)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, c)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
  };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ---------------------------------------------------------------- drawer */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var openers = $$('[data-drawer-open]');
    var closers = $$('[data-drawer-close]');
    var lastFocus = null;

    function setExpanded(state) {
      openers.forEach(function (b) { b.setAttribute('aria-expanded', state ? 'true' : 'false'); });
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      setExpanded(true);
      document.documentElement.style.overflow = 'hidden';
      var first = $('a,button', drawer);
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      setExpanded(false);
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* --------------------------------------------------------------- gallery */
  function initGallery(root) {
    $$('[data-gallery]', root || document).forEach(function (gal) {
      var buttons = $$('[data-gallery-thumb]', gal);
      var slides = $$('[data-gallery-slide]', gal);
      if (!buttons.length) return;

      function show(id) {
        slides.forEach(function (s) {
          var on = s.getAttribute('data-gallery-slide') === id;
          s.hidden = !on;
          var v = s.tagName === 'VIDEO' ? s : s.querySelector('video');
          if (v) { if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }
        });
        buttons.forEach(function (b) {
          b.setAttribute('aria-selected', b.getAttribute('data-gallery-thumb') === id ? 'true' : 'false');
        });
      }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { show(b.getAttribute('data-gallery-thumb')); });
      });
      gal.showMedia = show;
    });
  }

  /* --------------------------------------------------------- variant picker */
  function initProductForm(root) {
    $$('[data-product-form]', root || document).forEach(function (wrap) {
      var dataEl = $('[data-product-json]', wrap);
      if (!dataEl) return;

      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var form = $('form[action*="/cart/add"]', wrap);
      var idInput = $('[data-variant-id]', wrap);
      var priceEl = $('[data-variant-price]', wrap);
      var submitEl = $('[data-add-button]', wrap);
      var submitText = $('[data-add-text]', wrap);
      var soldEl = $('[data-sold-out]', wrap);
      var fmt = wrap.getAttribute('data-money-format') || '${{amount}}';
      var addLabel = wrap.getAttribute('data-add-label') || 'Add to cart';
      var soldLabel = wrap.getAttribute('data-sold-label') || 'Sold out';
      var gallery = $('[data-gallery]', document);

      var groups = $$('[data-option-group]', wrap);

      function selected() {
        return groups.map(function (g) {
          var on = $('[aria-checked="true"]', g);
          if (on) return on.getAttribute('data-value');
          var sel = $('select', g);
          return sel ? sel.value : null;
        });
      }

      function findVariant(vals) {
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] === null) continue;
            if (v.options[j] !== vals[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function render() {
        var v = findVariant(selected());
        if (!v) v = product.variants[0];
        if (!v) return;

        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, fmt);

        var available = v.available;
        if (submitEl) {
          submitEl.disabled = !available;
          submitEl.setAttribute('aria-disabled', available ? 'false' : 'true');
        }
        if (submitText) {
          submitText.textContent = available ? addLabel + ' — ' + money(v.price, fmt) : soldLabel;
        }
        if (soldEl) soldEl.hidden = available;

        // swap gallery to the variant's featured media when there is one
        if (gallery && gallery.showMedia && v.featured_media_id) {
          var thumb = $('[data-gallery-thumb="' + v.featured_media_id + '"]', gallery);
          if (thumb) gallery.showMedia(String(v.featured_media_id));
        }

        // keep the URL shareable
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      }

      groups.forEach(function (g) {
        $$('[data-value]', g).forEach(function (btn) {
          btn.addEventListener('click', function () {
            $$('[data-value]', g).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
            btn.setAttribute('aria-checked', 'true');
            var sel = $('select', g);
            if (sel) sel.value = btn.getAttribute('data-value');
            render();
          });
        });
        var sel = $('select', g);
        if (sel) sel.addEventListener('change', function () {
          $$('[data-value]', g).forEach(function (b) {
            b.setAttribute('aria-checked', b.getAttribute('data-value') === sel.value ? 'true' : 'false');
          });
          render();
        });
      });

      /* ---- gift-wrap bump: add a second line item in the same request ---- */
      if (form) {
        form.addEventListener('submit', function (e) {
          var bump = $('[data-bump]', wrap);
          if (!bump || !bump.checked) return;           // normal POST
          var bumpId = bump.getAttribute('data-bump-variant');
          if (!bumpId) return;                          // no product configured yet
          e.preventDefault();

          var items = [{ id: Number(idInput.value), quantity: 1 }];
          var props = {};
          $$('[name^="properties["]', form).forEach(function (p) {
            if (p.type === 'checkbox' && !p.checked) return;
            var key = p.name.replace(/^properties\[/, '').replace(/\]$/, '');
            if (p.value) props[key] = p.value;
          });
          if (Object.keys(props).length) items[0].properties = props;
          items.push({ id: Number(bumpId), quantity: 1 });

          if (submitEl) submitEl.disabled = true;
          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json(); })
            .then(function () { window.location.href = wrap.getAttribute('data-cart-url') || '/cart'; })
            .catch(function () { if (submitEl) submitEl.disabled = false; form.submit(); });
        });
      }

      render();
    });
  }

  /* ------------------------------------------------------------------ cart */
  function initCart() {
    var section = $('[data-cart-section]');
    if (!section) return;
    var sectionId = section.getAttribute('data-cart-section');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function refresh(body) {
      fetch(root + 'cart/change.js?sections=' + encodeURIComponent(sectionId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections[sectionId]) {
            var doc = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
            var fresh = doc.querySelector('[data-cart-section]');
            if (fresh) {
              section.innerHTML = fresh.innerHTML;
              bindCart();
              initProductForm(section);
            }
          } else {
            window.location.reload();
          }
          var count = $('[data-cart-count]');
          if (count && typeof data.item_count === 'number') {
            count.textContent = data.item_count;
            count.hidden = data.item_count === 0;
          }
        })
        .catch(function () { window.location.reload(); });
    }

    function bindCart() {
      $$('[data-qty-change]', section).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = Number(btn.getAttribute('data-line'));
          var input = $('input[data-line="' + line + '"]', section);
          var next = Math.max(0, Number(input.value) + Number(btn.getAttribute('data-qty-change')));
          input.value = next;
          refresh({ line: line, quantity: next });
        });
      });
      $$('input[data-line]', section).forEach(function (input) {
        input.addEventListener('change', function () {
          refresh({ line: Number(input.getAttribute('data-line')), quantity: Math.max(0, Number(input.value)) });
        });
      });
      $$('[data-remove-line]', section).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          refresh({ line: Number(a.getAttribute('data-remove-line')), quantity: 0 });
        });
      });

      var note = $('[data-cart-note]', section);
      if (note) {
        var t;
        note.addEventListener('input', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            fetch(root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: note.value })
            });
          }, 500);
        });
      }
    }

    bindCart();
  }

  /* ------------------------------------------------------------------ init */
  function boot() {
    initDrawer();
    initGallery();
    initProductForm();
    initCart();
    initLazyVideo();
    initCountdowns();
    initDealBar();
  }

  function initCountdowns() {
    var els = $$('[data-countdown-to]');
    if (!els.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = Date.now();
      $$('[data-countdown-to]').forEach(function (el) {
        var t = Date.parse(el.getAttribute('data-countdown-to'));
        if (!t) return;
        var d = t - now;
        if (d <= 0) { el.textContent = el.getAttribute('data-cd-done') || 'closed'; return; }
        var days = Math.floor(d / 86400000);
        var h = Math.floor(d % 86400000 / 3600000);
        var m = Math.floor(d % 3600000 / 60000);
        var sec = Math.floor(d % 60000 / 1000);
        el.textContent = days > 0
          ? days + 'd ' + pad(h) + 'h ' + pad(m) + 'm'
          : pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function initDealBar() {
    var bars = $$('[data-deal-bar]');
    if (!bars.length) return;
    function apply() {
      var now = Date.now();
      bars.forEach(function (bar) {
        var srcEl = bar.querySelector('[data-deal-schedule]');
        var sched = [];
        if (srcEl) { try { sched = JSON.parse(srcEl.textContent); } catch (e) {} }
        var active = null;
        for (var i = 0; i < sched.length; i++) {
          var st = Date.parse(sched[i].start);
          var en = Date.parse(sched[i].end);
          if (st <= now && now < en) { active = sched[i]; break; }
        }
        var label = bar.querySelector('[data-deal-label]');
        var timer = bar.querySelector('[data-countdown-to]');
        var link = bar.querySelector('[data-deal-link]');
        if (active) {
          if (label) label.textContent = active.label + ' ·';
          if (timer) timer.setAttribute('data-countdown-to', active.end);
          if (active.code && link) {
            link.setAttribute('href', '/discount/' + active.code + '?redirect=' + encodeURIComponent(location.pathname));
            bar.classList.add('dealbar--live');
          } else if (link) {
            link.removeAttribute('href');
            bar.classList.remove('dealbar--live');
          }
        } else {
          if (label) label.textContent = bar.getAttribute('data-close-label') || '';
          if (timer) timer.setAttribute('data-countdown-to', bar.getAttribute('data-close-iso') || '');
          if (link) link.removeAttribute('href');
          bar.classList.remove('dealbar--live');
        }
      });
    }
    apply();
    setInterval(apply, 30000);
  }

  function initLazyVideo() {
    var vids = document.querySelectorAll('video[data-video-src]');
    if (!vids.length) return;
    function load(v) {
      if (v.src) return;
      v.src = v.dataset.videoSrc;
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) {
      vids.forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          load(e.target);
          var p = e.target.play();
          if (p && p.catch) p.catch(function () {});
        } else if (e.target.src) {
          e.target.pause();
        }
      });
    }, { rootMargin: '300px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
